import { useReveal } from "@/hooks/useReveal";

/**
 * "Considered, Creative, Commercial" — the homepage intro block.
 * Verbatim wording supplied by the client.
 */
export default function WhyCEC() {
  const ref = useReveal();
  return (
    <section className="py-28 md:py-40 reveal hairline-top" ref={ref} data-testid="why-cec">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5 md:sticky md:top-32 self-start">
            <h2 className="h-display text-[clamp(2.2rem,5vw,4.4rem)]">
              <span className="block">Considered.</span>
              <span className="block">Creative.</span>
              <span className="block text-[#1E3668]">Commercial.</span>
            </h2>
          </div>

          <div className="md:col-span-7 md:pl-8 space-y-7 text-base md:text-lg text-graphite/85 leading-relaxed">
            <p>
              <span className="font-semibold">Carlton Elleker Chase</span> was established to bring
              something different to the legal market. Powered by smart, passionate lawyers and
              embracing technology and flexible working. Carlton Elleker Chase provides access to a
              network of experienced lawyers across a range of legal disciplines.
            </p>
            <p>
              The team's professional expertise is combined with commercial acumen and sector
              knowledge to assist with corporate and commercial dealings, dispute resolution,
              financial services advice and intellectual property counselling services.
            </p>
            <p>
              Our lawyers bring a different and more commercial approach because many have worked
              in house or established their own businesses. Many of our lawyers have seen things
              from the clients' perspective, resulting in a more tailored and higher level of
              customer service. We build enduring relationships with our clients and grow our
              understanding of their business as it grows.
            </p>
            <p>
              Working hand in hand with the best clients requires creativity, considered judgement,
              thinking outside the box and an exceptional understanding of our clients' needs. Our
              lawyers operate in an entrepreneurial and supportive meritocracy because we know if
              our team reaches its full potential then so do we.
            </p>
            <p>
              Thanks to our considered and creative approach to advice and highly commercial
              lawyers, we have built an unparalleled legal practice, particularly in the technology
              and media arenas, which makes us the firm of choice for high stakes disputes and
              commercial matters alike.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
